import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Collapse from '@material-ui/core/Collapse';
import React from 'react';
import SimpleForm from '../SimpleForm/SimpleForm';
import clsx from 'clsx';
// import useStyles from '../../Dashboard/styles'
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    stat: {},
    card: (props: any) => ({
        border: 'none',

        boxShadow: props.hideBorder ? 'none' : theme.shadows[1],
        '& [data-custom=SimpleToggle] [data-custom=SimpleToggleContent]': {
            padding: 0,
        },
        '& [data-custom=SimpleToggle] [data-custom=SimpleToggleHeader]': {
            // padding:0,
            paddingBottom: theme.spacing(1),
        },
    }),

    cardHeader: (props: any) => ({
        backgroundColor: props.headerBg || theme.palette.primary.main,
        color: props.headerBg === 'transparent' ? theme.palette.primary.main : theme.palette.common.white,
        fontSize: theme.typography.subtitle1.fontSize,
        '& .MuiSwitch-track': {
            backgroundColor: theme.palette.secondary.light,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: theme.palette.secondary.light,
        },
    }),
    cardContent: {
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(10),
    },
    cardHeaderContent: {
        textAlign: 'left',
    },
}));
interface ISimpleStatProps {
    count?: number; //object in the form {label:count}
    label: string; //primary label
    route: string;
    updateModule: any;
    active: boolean;
    children?: any;
}

export interface ISimpleToggleBlock {
    /** nave of the form field */
    name: string;

    /** content to pass through */
    children?: any;

    /** hides the boxShadow of the Card */
    hideBorder?: boolean;

    /** sizing of form heading */
    formHeadingSize?: 'h5' | 'subtitle1';

    /** callback on toggle */
    onSubmit: Function;

    /** Used as title of the component */
    label?: string;

    /** flex direction for the body of the card content */
    direction?: 'column' | 'row';

    /** What is the initial position of the toggle? */
    checked?: boolean;

    /** Whether to disabled the toggle */
    disabled?: boolean;

    /** Background color of SimpleToggleBlock Header */
    headerBg?: string;

    /** Color of header text */
    headerTextColor?: string;

    /** disabled toggle from appearing */
    disableToggle?: boolean;
    // metrics?: Array<{ route: string, label: string, stat: number }> //Used to display the data when the card is expanded
}
const SimpleToggleBlock = ({
    checked,
    children,
    direction,
    disableToggle,
    disabled,
    formHeadingSize,
    headerBg,
    headerTextColor,
    hideBorder,
    label,
    name,
    onSubmit,
}: ISimpleToggleBlock) => {
    const classes = useStyles({ hideBorder, headerBg, headerTextColor });
    return (
        <Card className={clsx(classes.card)} data-custom="SimpleToggle" data-cy={name}>
            <CardHeader
                action={
                    !disableToggle && (
                        <SimpleForm
                            defaultValues={{ [name]: checked }}
                            fields={[
                                {
                                    fieldSpecific: {
                                        disabled,
                                    },
                                    name,
                                    type: 'toggle',
                                },
                            ]}
                            hideButton={true}
                            id={name}
                            onSubmit={onSubmit}
                            submitOnChange={true}
                        />
                    )
                }
                className={classes.cardHeader}
                classes={{ content: classes.cardHeaderContent }}
                data-custom="SimpleToggleHeader"
                title={label}
                titleTypographyProps={{ variant: formHeadingSize ? formHeadingSize : 'h5' }}
            />
            <Collapse in={checked} timeout="auto" unmountOnExit>
                <CardContent classes={{ root: classes.cardContent }} data-custom="SimpleToggleContent">
                    {children}
                </CardContent>
            </Collapse>
        </Card>
    );
};

export default SimpleToggleBlock;
